import React from "react";
import "./Download.css";
import Navbar from "../../components/Navbar/Navbar";
import DownloadIcon from "../../assets/download.svg";
import LogoDownload from "../../assets/LogoDownload.png";
import LogoDownloadFooter from "../../assets/LogoDownloadFooter.svg";
import backgroundSquareDownload from "../../assets/backgroundSquareDownload.webp";

const Download = () => {
    return (
        <>
            <title>Download Oakmate Chrome Extension</title>
            <meta
                name="description"
                content="Get the Oakmate extension for Chrome. Start reviewing your Chess.com and Lichess games with powerful, premium-grade analysis tools today."
            />
            <div className="downloadpage">
                <img
                    src={backgroundSquareDownload}
                    alt="Background"
                    className="backgroundSquareDownload"
                />
                <Navbar isDownloadVisible={false} />
                <div className="download-container">
                    <div className="main-wrapper">
                        <div className="logo-wrapper">
                            <img
                                src={LogoDownload}
                                alt="Logo"
                                className="LogoDownload"
                            />
                        </div>
                        <div className="text-wrapper">
                            <div className="text-title">
                                The ultimate game review tool
                            </div>
                            <div className="text-sub">Own your game review</div>
                        </div>
                        <button
                            className="download-cta"
                            onClick={() => {
                                window.open(
                                    "https://chromewebstore.google.com/detail/oakmate-game-review/fdledmdlgggnfddaeillbpahblnblbne",
                                    "_blank",
                                    "noopener,noreferrer"
                                );
                            }}
                        >
                            <div className="download-cta-text">
                                Download for Chrome
                            </div>
                            <img
                                src={DownloadIcon}
                                className="download-cta-icon"
                                alt="Download Icon"
                            />
                        </button>
                    </div>
                    <div className="sub-downloads-wrapper">
                        <div
                            className="downloadfor"
                            onClick={() => {
                                window.open(
                                    "https://chromewebstore.google.com/detail/oakmate-game-review/fdledmdlgggnfddaeillbpahblnblbne",
                                    "_blank",
                                    "noopener,noreferrer"
                                );
                            }}
                        >
                            Download for Chrome
                        </div>
                        <div className="downloadfor-separator" />
                        <div
                            className="downloadfor"
                            onClick={() => {
                                window.open(
                                    "https://chromewebstore.google.com/detail/oakmate-game-review/fdledmdlgggnfddaeillbpahblnblbne",
                                    "_blank",
                                    "noopener,noreferrer"
                                );
                            }}
                        >
                            Download for Safari
                        </div>
                        <div className="downloadfor-separator" />
                        <div
                            className="downloadfor"
                            onClick={() => {
                                window.open(
                                    "https://chromewebstore.google.com/detail/oakmate-game-review/fdledmdlgggnfddaeillbpahblnblbne",
                                    "_blank",
                                    "noopener,noreferrer"
                                );
                            }}
                        >
                            Download for Firefox
                        </div>
                        <div className="downloadfor-separator" />
                        <div className="downloadfor">Web Application</div>
                    </div>
                </div>
                <div className="copyright">
                    Copyright © 2025 Oakmate. All rights reserved
                </div>
                <div className="oakmatebackgroundlogo-wrapper">
                    <img
                        src={LogoDownloadFooter}
                        alt="Logo background"
                        className="LogoDownloadFooter"
                    />
                    <div className="maskdownloadfooter" />
                </div>
            </div>
        </>
    );
};

export default Download;
